//cn.js

// import zhLocale from 'element-ui/lib/locale/lang/zh-cn'
import header from './cn/header'
import footer from './cn/footer'
import main from './cn/main'
import plist from './cn/plist'
import pdetail from './cn/pdetail'
import login from './cn/login'
import forget from './cn/forget'
import register from './cn/register'
import center from './cn/center'
import cmain from './cn/cmain'
import cgoods from './cn/cgoods'
import cbranch from './cn/cbranch'
import caddress from './cn/caddress'
import cdepartment from './cn/cdepartment'
import cmember from './cn/cmember'
import cdata from './cn/cdata'
import cpwd from './cn/cpwd'
import cqcart from './cn/cqcart'
import cqorder from './cn/cqorder'
import cart from './cn/cart'
import costatus from './cn/costatus'
import corder from './cn/corder'
import csales from './cn/csales'
import cmonth from './cn/cmonth'
import ccoll from './cn/ccoll'
import ccall from './cn/ccall'
import getattr from './cn/getattr'
import breadcrumb from './cn/breadcrumb'
import instructions from './cn/instructions'
import service from './cn/service'
import repair from './cn/repair'

const cn = {
    message: {
        header,
        footer,
        main,
        plist,
        pdetail,
        login,
        forget,
        register,
        center,
        cmain,
        cgoods,
        cbranch,
        caddress,
        cdepartment,
        cmember,
        cdata,
        cpwd,
        cqcart,
        cqorder,
        cart,
        costatus,
        corder,
        csales,
        cmonth,
        ccoll,
        ccall,
        getattr,
        breadcrumb,
        instructions,
        service,
        repair
    },
    public: {
        confirmBtn: "確定",
        cancelBtn: "取消",
        submitBtn: "提交",
        modifyBtn: "修改",
        delBtn: "刪除",
        searchBtn: "查詢",
        quoteCart: "報價車",
        shoppingCart: "購物車",
        notLogin: "您還未登錄，請先登錄！",
        goLogin: "去登錄",
        delSucc: "刪除成功！",
        addSucc: "添加成功！",
        modifySucc: "修改成功！",
        remarks: "剩餘可分配額度：{balance}",
        radio1: "是",
        radio2: "否",
        authorityQuote: "您沒有報價權限，請聯繫管理員！",
        authorityOrder: "您沒有下單權限，請聯繫管理員！",
        keyWord: "請輸入關鍵字",
        email1: "請輸入郵箱",
        email2: "郵箱格式不正確，請重新輸入",
        emailTips: "多郵箱時請用英文逗號分隔"
    }
    // ...zhLocale
}

export default cn